module.exports = __webpack_public_path__ + "static/media/en.2576ac2c.png";